








import { Component, Vue } from 'vue-property-decorator';
import BoxTile from '@/components/ui/BoxTile.vue';

@Component({
  components: {
    BoxTile
  },
})
export default class GoalWrapper extends Vue {

}
